export default __webpack_public_path__ + "static/media/login_bg.985c8090.svg";